import WorkspaceShell from "./WorkSpace";
import Library from "../../Library/Library";
import MediaViewer from "../../Viewer/MediaViewer";

// Wrap the forwardRef component in a plain function component
function ViewerWrapper(props) {
  return <MediaViewer {...props} />;
}

export default function RightPanel({ onAddItem }) {
  return <WorkspaceShell LibraryComponent={Library} ViewerComponent={ViewerWrapper} onAddItem={onAddItem} />;
}